import { Injectable} from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { AuthService } from '../components/auth.servicice';

@Injectable({
  providedIn: 'root'
})
export class RITService {

  constructor(private http: HttpClient, private authService: AuthService) {}

  getCifradoXLiquidadores(): Observable<any> {
    const user = this.authService.getValueUser();
    const config = this.authService.getValueConfig();
    const identificacionUsuario = user.tipoId + "-" + user.nroId;
    //const parRIT = identificacionUsuario + "-" + config.fechaServidor.substring( 6,8 ) + config.fechaServidor.substring(4,6) + config.fechaServidor.substring(0,4) 
    const fecha = new Date();
    const parRIT = identificacionUsuario + "-" + fecha.getDate().toString().padStart(2, '0') + (fecha.getMonth() + 1).toString().padStart(2, '0') + fecha.getFullYear().toString();
    let url = config.urlCifradoXLiquidadores + parRIT;
    const authHeaders = new HttpHeaders().set('Content-Type', 'application/json')
    const httpOptions = { headers: authHeaders};
    if(environment.production == false && environment.proxyOfinaVirtual != null){
      url = url.replace(environment.hostOfinaVirtual, environment.proxyOfinaVirtual);
    }
    return this.http.get(`${url}`, httpOptions);
  }

}
